import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HubHomePageComponent } from './hub-home-page/hub-home-page.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { FSLoaderFactory } from '../app.module';
import { SharedModule } from '../shared/shared.module';
import { AdContainerComponent } from './ad-container/ad-container.component';
import { HubComponentsModule } from '../hub-components/hub-components.module';
import { HttpClientModule } from '@angular/common/http';
import { CpjContainerComponent } from './cpj-container/cpj-container.component';
import { LinkedinContainerComponent } from './linkedin-container/linkedin-container.component';
import { LoginComponent } from './login/login.component';
import { HomeModule } from "src/app/home/home.module";

@NgModule({
  declarations: [HubHomePageComponent, AdContainerComponent, CpjContainerComponent, LinkedinContainerComponent, LoginComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    TranslateModule,
    SharedModule,
    HubComponentsModule,
    HomeModule
],
  exports: [
    ReactiveFormsModule,
    TranslateModule
  ]
})
export class PagesModule { }
